/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationDetailsOverviewRequest extends models.ScheduleRecommendationDetailsBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationDetailsOverviewRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationDetailsOverviewRequest>): ScheduleRecommendationDetailsOverviewRequest {
        let obj = Object.assign(new ScheduleRecommendationDetailsOverviewRequest(), model);
        ScheduleRecommendationDetailsOverviewRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationDetailsOverviewRequest>): ScheduleRecommendationDetailsOverviewRequest {
        if (!model) return null;
        return ScheduleRecommendationDetailsOverviewRequest.newInstance(<ScheduleRecommendationDetailsOverviewRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationDetailsOverviewRequest) {
        if (!obj) return;

        models.ScheduleRecommendationDetailsOverviewRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationDetailsOverviewRequest): boolean {
        if (models.ScheduleRecommendationDetailsBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationDetailsOverviewRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
